import { FormLabel as MUIFormLabel, FormLabelProps } from '@mui/material';

export { type FormLabelProps } from '@mui/material';

export function FormLabel(props: FormLabelProps) {
  return <MUIFormLabel {...props} />;
}
